// 防抖
export function debounce(func, delay, immediate) {
    // 接受三个参数，func：执行函数，delay：延迟时间，immediate：是否立即执行
    let timer = null; // 定义一个延时器；
    return function (...args) {
        let that = this;
        let isImmediate = !timer && immediate // 判断下是否立即执行
        clearTimeout(timer)
        timer = setTimeout(() => {
            clearTimeout(timer) // 清除计时器
            timer = null // 清除计时器
            if (!immediate) { func.apply(that, args) } // 如果是不是立即执行，执行这一步
        }, delay)
        if (isImmediate) { // 如果是立即执行，执行这一步
            func.apply(that, args)
        }
    }
}